import { ToolbarModuleExtension } from '@blocksuite/hive-shared/services';
import { BlockFlavourIdentifier } from '@blocksuite/std';

import { builtinInlineLinkToolbarConfig } from './link-node/configs/toolbar.js';

export const linkToolbar = ToolbarModuleExtension({
  id: BlockFlavourIdentifier('hive:link'),
  config: builtinInlineLinkToolbarConfig,
});
